
// Actions
export enum CommonActionTypes {
  ToggleLoading = '[Common] Toggle Loading'
}

export class CommonToggleLoading {
  readonly type = CommonActionTypes.ToggleLoading;
  constructor(public payload: boolean) { }
}

// State & Reducer
export interface CommonState {
  isLoading: boolean;
}

export const initialCommonState: CommonState = {
  isLoading: false
};

export function commonReducer(state = initialCommonState, action: any): CommonState {
  switch (action.type) {
    case CommonActionTypes.ToggleLoading:
      return {
        ...state,
        isLoading: action.payload
      };
    default:
      return state;
  }
}

export const getCommonState = (state: { common: CommonState }) => state.common;
export const getIsLoading = (state: CommonState) => state.isLoading;